/**
 * 存放一些常用数据
 */

// 用于datePicker组件配置日期格式
export const formatDate = {
  year: 'YYYY',
  month: 'MM',
  date: 'DD'
};

// 图表颜色值
export const colors = ['#1890ff', '#13c2c2', '#2fc25b', '#facc14', '#223273', '#8543e0'];

export const character = /^[\u4E00-\u9FA5A-Za-z0-9_]+$/;
export const isMobile = /^1[3456789]\d{9}$/;
